import React, { useContext, useEffect } from 'react'
import { DataContext } from '../../context/DataContext'
import { IOpenCloseModalProps } from '../../interfaces/IOpenCloseModalProps'
import { Grid } from '../common/grid/Grid'
import { GridItem } from '../common/grid/GridItem'
import { useForm } from 'react-hook-form'
import { Organisation } from '../../api/schemas/schema'
import { t } from '../../i18n/i18n'
import { ModalActions } from '../common/modal/Modal'
import { Button } from '@fluentui/react-components'
import { handleMessage } from '../../helpers/stateHelper'
import { api } from '../../helpers/apiHelper'
import { InvoiceDetailsForm } from './InoiceDetailsForm'
import { createOrganisationUpdateEmailRequest } from '../../helpers/emailHelper'
import { DraggableModal } from '../common/modal/DraggableModal'
import { Form } from '../common/form/Form'

export const ModalInvoiceDetails = ({ open, closeModal }: IOpenCloseModalProps) => {
   const dataContext = useContext(DataContext)
   const { setRootState } = dataContext
   const { organisation } = dataContext.state
   const organisationForm = useForm<Organisation>({})
   const {
      reset,
      handleSubmit,
      formState: { isDirty, isSubmitting },
   } = organisationForm

   useEffect(() => {
      if (organisation) {
         reset(organisation)
      }
   }, [organisation, reset])

   const handleSaveClick = handleSubmit(async (data: Organisation) => {
      try {
         const updatedOrganisation = await api().updateOrganisation(data)

         const emailRequest = createOrganisationUpdateEmailRequest(dataContext, data)
         if (emailRequest) {
            await api().sendUpdateNotificationToAdmin(emailRequest)
         }

         setRootState((prev) => ({
            ...prev,
            organisation: updatedOrganisation.data,
         }))

         closeModal()
         handleMessage(setRootState, 'success', t('ItemSuccessfullySaved', { Item: t('InvoiceDetails') }))
      } catch (error) {
         handleMessage(setRootState, 'error', t('SomethingWentWrong'), t('CouldNotUpdateItem', { item: t('InvoiceDetails') }))
      }
   })

   const closeAndReset = () => {
      closeModal()
      reset(organisation)
   }

   return (
      <DraggableModal open={open} title={t('InvoiceDetails')} onClose={closeAndReset}>
         <Form onSubmit={handleSaveClick}>
            <Grid gap="L">
               <InvoiceDetailsForm organisationForm={organisationForm} />
               <GridItem size={'12/12'}>
                  <ModalActions>
                     <Button appearance="secondary" onClick={closeAndReset} disabled={isSubmitting}>
                        {t('Cancel')}
                     </Button>
                     <Button appearance="primary" type="submit" disabled={!isDirty || isSubmitting}>
                        {t('Save')}
                     </Button>
                  </ModalActions>
               </GridItem>
            </Grid>
         </Form>
      </DraggableModal>
   )
}
